/**
 * @description The status of the order, in transit, paid, canceled, etc.
 */
export enum OrderStatusType {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Canceled = 'Canceled',
  ToCancel = 'ToCancel',
  Unfunded = 'Unfunded',
  InReview = 'InReview',
  Expired = 'Expired',
  ReadyForPickup = 'ReadyForPickup',
  ConfirmationExpired = 'ConfirmationExpired',
  InProcess = 'InProcess',
  Paid = 'Paid',
  Refunded = 'Refunded',
  DocumentsRequired = 'DocumentsRequired',
  DocumentsInReview = 'DocumentsInReview',
  DocumentsResubmit = 'ResubmitDocuments',
  
  PAYMENT_PENDING_NUM_CODE = 10,
  PROCESSING_NUM_CODE = 20,
  BENEFICIARY_CAN_COLLECT_NUM_CODE = 30,
  COLLECTED_BY_BENEFICIARY_NUM_CODE = 40,
  CANCELLED_NUM_CODE = 50
}


// WEBPACK FOOTER //
// ./src/model/types/order-status-type.ts